import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'found';
import { Dropdown, Grid, Icon } from 'semantic-ui-react';

class PaymentsComponent extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    location: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.handleStatusFilterChange = this.handleStatusFilterChange.bind(this);
  }

  handleStatusFilterChange(e, { value }) {
    switch (value) {
      case 'outstanding':
        this.props.router.replace('/financials/payments/outstanding');
        break;
      case 'refunds':
        this.props.router.replace('/financials/payments/refunds');
        break;
      default:
        this.props.router.replace('/financials/payments');
        break;
    }
  }

  render() {
    const statusOptions = [
      { text: 'Completed Payments', value: 'completed' },
      { text: 'Outstanding Payments', value: 'outstanding' },
      { text: 'Refunds', value: 'refunds' }
    ];
    const statusMappings = {
      completed: 'Completed Payments',
      outstanding: 'Outstanding Payments',
      refunds: 'Refunds'
    };
    const status = ((pathname) => {
      switch (pathname) {
        case '/financials/payments/outstanding':
          return 'outstanding';
        case '/financials/payments/refunds':
          return 'refunds';
        default:
          return 'completed';
      }
    })(this.props.location.pathname);

    return (
      <Grid stackable>
        <Grid.Row columns='equal' only='computer tablet'>
          <Grid.Column>
            <Dropdown
              button
              basic
              floating
              trigger={
                <span>
                  <Icon name='filter' /> {statusMappings[status]}
                </span>
              }
              onChange={this.handleStatusFilterChange}
              options={statusOptions}
              value={status}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row columns='equal' only='mobile'>
          <Grid.Column>
            <Dropdown
              button
              basic
              fluid
              floating
              trigger={
                <span>
                  <Icon name='filter' />{' '}
                  {statusMappings[status]}
                </span>
              }
              onChange={this.handleStatusFilterChange}
              options={statusOptions}
              value={status}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={16}>
            {this.props.children}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default withRouter(PaymentsComponent);



// WEBPACK FOOTER //
// ./webpack/components/Financial/Payments/PaymentsComponent.js